import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import MuiTable from "../MuiTable/MuiTable";

import "./MyTransactions.css";

const MyTransactions = ({ disableInitial }) => {
  useEffect(() => {
    disableInitial(false);
  }, []);
  const columns = [
    "Invoice No",
    "QUA",
    "PAID $",
    "DUE $",
    "DUE DATE",
    "PURCHASED ON",

    {
      name: "NO OF JOBS",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const mainkey = tableMeta.rowData[5];

          return <div className="jobs-highlight">view 6 Jobs</div>;
        },
      },
    },
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const mainkey = tableMeta.rowData[5];

          return (
            <div className="actions-cart">
              <Button variant="outlined" className="save-btn">
                Download Invoice
              </Button>
              {/* onClick={() => deleteDocument(tableMeta.rowData[0])} */}
            </div>
          );
        },
      },
    },
  ];
  const data = [
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
    ["01", "2", "$1000", ".......", ".......", "27/08/2021"],
  ];
  return (
    <div className="transactions-container transactions-searchbar">
      <div className="transactions-title">My Transactions</div>
      <div className="searchContainer">
        <div className="searchIcon"></div>
        <input
          className="searchBox"
          type="search"
          name="search"
          placeholder="Search..."
        />
      </div>

      <div className="table-transactions">
        <MuiTable columns={columns} data={data} />
      </div>
    </div>
  );
};

export default MyTransactions;
